module.exports = __webpack_public_path__ + "img/interbank.2578470a.svg";